import { PinIcon } from '../../../../components/primitives/Icon';
import styles from './LocationTag.module.css';

interface Props {
  street: string;
  size?: 'sm' | 'md';
}

/**
 * Pale-blue-gray pill showing a vendor's street/location. Non-interactive —
 * row-level navigation owns the "where is this" action. Renders nothing if
 * `street` is empty so consumers can pass optional data without conditionals.
 */
export function LocationTag({ street, size = 'md' }: Props) {
  const trimmed = street.trim();
  if (!trimmed) return null;
  return (
    <span
      className={`${styles.tag} ${size === 'sm' ? styles.sm : ''}`}
      aria-label={`Location: ${trimmed}`}
    >
      <PinIcon size={12} aria-hidden className={styles.pin} />
      <span className={styles.text}>{trimmed}</span>
    </span>
  );
}
